// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2II5m","calendarButtons":"ClockData_calendarButtons__1aGuF"};